import { Box, type BoxProps, webPalette } from '@munifocus/ui';

export function Kicker({ sx, color, ...rest }: BoxProps & { color?: string }) {
  return (
    <Box
      sx={{
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: '0.22em',
        textTransform: 'uppercase',
        color: color ?? webPalette.tealInk,
        ...sx,
      }}
      {...rest}
    />
  );
}
